import { Box, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { NfcCardScreen, NfcCardScreenState, nfcCardPath } from 'lib/nfcCardScreens';

type Props = {
	card: NfcCard;
	disabled?: boolean;
	onBlock: (card: NfcCard) => any;
	onUnblock: (card: NfcCard) => any;
	onChangeExpiration: (card: NfcCard) => any;
};

/** The actions of a card in the listing, as big buttons in two columns to be tapped on a phone. */
export default function Actions({ card, disabled, onBlock, onUnblock, onChangeExpiration }: Props) {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const location = useLocation();

	// The screen gets the listing as it is now, so its back button returns to the same filters and page
	const open = (screen: NfcCardScreen) => {
		const state: NfcCardScreenState = { listing: `${location.pathname}${location.search}` };
		navigate(nfcCardPath(card._id, screen), { state });
	};

	return (
		<Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1 }}>
			<Button variant="outlined" size="large" onClick={() => open('saldo')}>
				{t('nfc:balance')}
			</Button>

			<Button variant="outlined" size="large" onClick={() => open('cargas')}>
				{t('nfc:orders')}
			</Button>

			<Button variant="outlined" size="large" onClick={() => open('movimientos')}>
				{t('nfc:transactions')}
			</Button>

			{card.state === 'active' && (
				<Button variant="outlined" size="large" onClick={() => onBlock(card)} color="error" disabled={disabled}>
					{t('nfc:block')}
				</Button>
			)}

			{/* An expired card cannot be unblocked: the API refuses it until its expiration is changed */}
			{card.state === 'blocked' && (
				<Button variant="outlined" size="large" onClick={() => onUnblock(card)} color="success" disabled={disabled}>
					{t('nfc:unblock')}
				</Button>
			)}

			<Button variant="outlined" size="large" onClick={() => onChangeExpiration(card)} disabled={disabled}>
				{t('nfc:changeExpiration')}
			</Button>
		</Box>
	);
}
